<template lang="pug">
	div#search-page
		b-container(v-show="!showError")
			b-row
				b-col.main(lg="8" cols="12")
					b-row.search-row(no-gutters)
						b-col.search-box-container(no-gutters cols="12" md="10")
							form(@submit.prevent="search()")
								h1.hidden Search
								sfc-input.search-box.d-none.d-md-block(v-model="searchTerm" :flat="false" :searchIcon="true" placeholder="Search")
								sfc-input.search-box.search-box-small.d-inline-block.d-md-none(v-model="searchTerm" :flat="false" :searchIcon="false" placeholder="Search")
								a.btn.sfc-blue.button-loupe.d-inline-block.d-md-none(@click="search()")
									img(:src="`${$store.state.config.s3ResourceHost}/images/icon-search-white.svg`" alt="Search Icon")
								input.d-none(type="submit")
						b-col.button-search-container.d-none.d-md-inline-block(md="2")
							a.btn.sfc-blue.search-button(@click="!disableSearchAsComponent ? search() : goToSearch(searchTerm)")
								| Search
					b-row.brief-results.brief-search-results(no-gutters v-show="total != 0 && actualSearchTerm != ''")
						b-col(cols="9")
							| You searched for '{{actualSearchTerm}}'&nbsp;
							span.d-none.d-lg-inline-block and got&nbsp;
							span.d-none.d-lg-inline-block.bold {{total | currency("","0")}} results
						b-col.text-right.d-none.d-lg-inline-block(cols="3")
							span(v-show="actualSearchTerm != '' || searchOnlyByTag")
								| Showing {{((pageNumber - 1) * 12) + 1}} - {{lastPageResultsTotal()}}
					b-row.brief-results.brief-search-no-results(no-gutters v-show="total == 0")
						b-col(cols="12")
							| You searched for '{{actualSearchTerm}}' and got&nbsp;
							span.bold no results
					.search-results(:class="{'with-border-bottom': actualSearchTerm != '' && total > 0}")
						b-row.result(no-gutters v-for="(result, index) of results" :key="index")
							b-col.search-info-container(cols="12")
								h2.title
									a(:href="result._source.url")
										| {{result._source.title}}
								.author-date
									span.tag.article(:class="tagClass(result._source.page_tag)")
										| {{result._source.page_tag}}
								.snippet
									span(v-html="paragraphTruncator(result._source.description)")

							.ad.d-none.d-lg-block(v-if="index == 5 && total > 6")
								no-ssr
									sfc-dfp-ad(ad-unit='savingforcollege_college_savings_101_page_topleaderboard' sizes='[[600,230], [728,90]]')
							.ad.d-block.d-md-none(v-if="index % 11 == 0 && total > 12 && index / 10 < 10 && index > 10")
								no-ssr
									sfc-dfp-ad(:ad-unit='`savingforcollege_other_mobile_leaderboard_${(index % 11) + 1}`' sizes='[[320,50]]' :mobile="true")
						.mobile-mark.d-block.d-lg-none(v-observe-visibility="{callback: loadMoreResults, intersection:{rootMargin: '400px'}}")

						spinner(v-show="loadingMoreMobile" size="20")


					div(v-show="(actualSearchTerm != '' || searchOnlyByTag)")
						.search-page-buttons.d-none.d-lg-block
							a.btn.sfc-blue.page-buttons(@click="search('previous', $event, searchOnlyByTag)" v-show="pageNumber > 1")
								span.arrow-left
								span Previous
							a.btn.sfc-blue.page-buttons.button-next(@click="search('next', $event, searchOnlyByTag)" v-show="pageNumber < Math.ceil(total/10)")
								span Next
								span.arrow-right

				b-col.side.d-none.d-lg-inline-block()
					ul.pre-searchs
						li.first-title Results from
						li(v-for="tag of tags" :key="tag._source.title" :class="{'active': currentResultFrom == tag._source.title}" @click="!disableSearchAsComponent ? setCurrentResultFrom(tag._source.title) : goToSearch(tag._source.title)") {{tag._source.title}}
					no-ssr
						sfc-sidebar.d-md-none.d-lg-block.d-sm-none.d-none.sidebar-content

		b-container(v-show="showError")
			b-row
				b-col.main(cols="12")
					.error-container
						.error-image-container
							img(:src="`${$store.state.config.s3ResourceHost}/images/icon-search-no-result-blue.svg`" alt="Search had no results")
						h2.error-title Oops! Something went wrong
						p.error-subtitle Please try searching again
</template>

<style lang="stylus">
	@import '~assets/css/variables.styl'
	#search-page
		.search-box
			@media(max-width: 767px)
				font-size: body-font-size-md

			.search-icon
				height: 17px
				width: 17px
				margin-left: 20px
				position: absolute
				top: 10px
			input
				padding: 8px 8px 8px 50px
				font-size: body-font-size-md
				box-shadow-tb()

			&.search-box-small
				width: 80%
				input
					padding: 8px

		.btn.sfc-blue
			font-weight: body-font-weight-strong
			margin: 0
		.side
			.sidebar-large
			.text-ads
			.sponsor-center
				float: left
				div
					padding-left: 0
</style>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	#search-page
		font-family: home-font!important
		.main
			padding-top: 30px
			padding-right: 30px

		.separator
			height: 1px
			border-top: 1px solid sfc-pale-gray
			margin-top: 20px
			margin-bottom: 40px

		.search-row
			.search-box-container
				padding-right: 30px
				@media(max-width: 767px)
					padding-right: 0px
			.search-box
				height: 40px

			.button-search-container
				padding: 0
				text-align: right
				a.search-button
					padding: 7px 25px

			a.button-loupe
				float: right
				padding: 7px 20px

		.hidden
			display: none

		.search-results
			margin-top: 40px
			margin-bottom: 52px
			&.with-border-bottom
				border-bottom: 1px solid sfc-pale-gray
				@media(max-width: 991px)
					border-bottom: 0



		.search-info-container

			h2.title
				font-size: body-font-size-lg-plus
				font-weight: body-font-weight-strong
				margin: 0
				@media(max-width: 500px)
					font-size: body-font-size-lg
				a
					color: body-font-color
			.tag
				padding: 5px 15px
				border-radius(2px)
				text-transform: none
				font-size: body-font-size-xxs
				color: #FFF
				border: 0
				&.article
					background-color: #106cc6
				&.plan-info
					background-color: #21b163
				&.guides
					background-color: #f5a623
				&.tools-and-calculators
					background-color: #ff5033
				&.q-and-a
					background-color: #95a4b5

			.snippet
				font-size: body-font-size-md
				margin-top: 18px


		.brief-search-results
			font-size: body-font-size-sm
			color: #95a4b5

		.brief-search-no-results
			color: body-font-color

		.brief-results
			border-bottom: 1px solid sfc-pale-gray
			padding-bottom: 10px
			margin-top: 10px
			.bold
				font-weight: body-font-weight-strong

		.result
			margin-bottom: 30px
			.ad
				border-top: 1px solid sfc-pale-gray
				border-bottom: 1px solid sfc-pale-gray
				padding: 30px 0
				margin: 50px auto 20px



		ul.pre-searchs
			padding: 0
			li
				font-weight: body-font-weight !important
				list-style: none
				color: sfc-blue-link
				border-left: 4px solid #f0f2f6
				padding: 0 0 5px 0
				padding-left: 25px
				font-size: body-font-size-sm

				&:hover
					cursor: pointer
					text-decoration: underline
					border-left: 4px solid sfc-blue-link

				&.active
					color: body-font-color
					border-left: 4px solid sfc-blue-link

				&.first-title
					color: body-font-color
					font-weight: body-font-weight-strong !important
					padding-bottom: 15px
					font-size: body-font-size-md

				&.first-title
					&:hover
						text-decoration: none
						cursor: auto
						border-left: 4px solid #f0f2f6

				&.active
					&:hover
						text-decoration: none
						cursor: auto

		.side
			padding: 0
			max-height: 100%
			overflow: hidden
			padding-top: 30px
			padding-left: 50px

		.search-page-buttons
			text-align: right
			margin-bottom: 84px
			.page-buttons
				position: relative
				width: 185px
				text-align: center
				padding: 10px 0
				.arrow-left
					position: absolute
					top: 17px
					left: 24px
					border-bottom: 5px solid transparent
					border-right: 6px solid #FFF
					border-top: 5px solid transparent
				.arrow-right
					position: absolute
					top: 17px
					right: 24px
					border-bottom: 5px solid transparent
					border-left: 6px solid #FFF
					border-top: 5px solid transparent
				&.button-next
					margin-left: 20px

		.error-container
			text-align: center
			.error-image-container
				margin-top: 50px
			.error-title
				margin-top: 40px
				color: sfc-blue-link
			.error-subtitle
				font-weight: body-font-weight
				margin-bottom: 150px

		.sidebar-container
			position: relative
			.sidebar-content
				position: sticky
</style>

<script>
	import Vue from 'vue'
	import SfcSidebar from '@/common/components/sfc-sidebar.vue'
	import SfcBreadcrumbs from '@/common/components/sfc-breadcrumbs'
	import SfcTrackingService from "@/lib/sfc-tracking-service.js"
	import SfcSlider from '@/common/components/sfc-slider'
	import VueObserveVisibility from 'vue-observe-visibility'
	import Spinner from 'vue-simple-spinner/src/components/Spinner.vue'
	Vue.use(VueObserveVisibility)

	export default {
		components: {
			SfcSidebar,
			SfcBreadcrumbs,
			SfcSlider,
			Spinner
		},
		watchQuery: true,
		async mounted(){
			this.getSearchResults()
		},
		props:[
			'disableSearchAsComponent' // used to create links to /search instead of directly calling search()
		],
		data(){
			return {
				ready: false,
				searchTerm:"",
				actualSearchTerm: "",
				currentResultFrom: "All",
				pageNumber: 1,
				loadingMoreMobile: false,
				keepSearchingMobile: true,
				searchOnlyByTag: false,
				total: 0,
				results: [],
				tags: [],
				showError: false,
			}
		},
		methods:{
			async getSearchResults(){
				let response
				let actualSearchTerm = ""
				let searchTerm = ""
				let elasticQuery
				let elasticCountQuery
				let pageNumber = 1
				let tags = []
				let searchOnlyByTag = false
				let currentResultFrom = "All"
				let results = []
				let total = 0
				let showError = false

				try{
					let tagQuery = {
						sort: [
							{
								amount: {
									order: "desc"
								}
							}
						]
					}

					let tagResponse = await this.$axios.get(
						`${this.$store.state.config.searchApiHost}/page-tags/_search`,
						{
							params: {
								source: JSON.stringify(tagQuery),
								source_content_type: 'application/json'
							},
							auth:{
								username:"sfc_query",
								password:"sfc_query"
							}
						}
					)

					tags = tagResponse.data.hits.hits
					let tagsForCompare = tags.map( tag => tag._source.title)

					if(this.$route.query.page){
						pageNumber = parseInt(this.$route.query.page)
						if(isNaN(pageNumber)){
							pageNumber = 1
						}
					}

					if(pageNumber > 999){
						pageNumber = 999
					}

					if(this.$route.query.tag && tagsForCompare.indexOf(this.$route.query.tag) != -1){
						actualSearchTerm = this.$route.query.tag
						searchOnlyByTag = true
						currentResultFrom = this.$route.query.tag
						elasticQuery = {
							size: 12,
							from: ((pageNumber - 1) * 12),
							query: {
								bool:{
									should:[
										{match_phrase: {tags: this.$route.query.tag}}
									]
								}
							},
							_source: ["title", "description", "url", "page_tag"]
						}

					}else{
						if(this.$route.query.q){
							actualSearchTerm = this.$route.query.q
							searchTerm = this.$route.query.q

							elasticQuery = {
								size: 12,
								from: ((pageNumber - 1) * 12),
								query: {
									bool:{
										should:[
											{match: {title: {query: actualSearchTerm, boost: 6}}},
											{match: {page_tag: {query: actualSearchTerm, boost: 5}}},
											{match: {tags: {query: actualSearchTerm, boost: 3}}},
											{match: {description: {query: actualSearchTerm, boost: 4}}},
											{match: {content: {query: actualSearchTerm, boost: 2}}},
											{match: {author: actualSearchTerm}},
										]
									}
								},
								_source: ["title", "description", "url", "page_tag"]
							}
						}else{
							elasticQuery = {
								size: 12,
								query: {
									match_all: {}
								},
								sort:[{date: {order: "desc"}}],
								_source: ["title", "description", "url", "page_tag"]
							}
						}
					}

					response = await this.$axios.get(
						`${this.$store.state.config.searchApiHost}/pages/_search`,
						{
							params: {
								source: JSON.stringify(elasticQuery),
								source_content_type: 'application/json'
							},
							auth:{
								username:"sfc_query",
								password:"sfc_query"
							}
						}
					)

					results = response.data.hits.hits
					total = response.data.hits.total

					if(results.length == 0 && total > 0 && pageNumber > 1){
						pageNumber = Math.ceil(total / 10)
						elasticQuery = {
							size: 12,
							from: ((pageNumber - 1) * 12),
							query: {
								bool:{
									should:[
										{match: {title: {query: actualSearchTerm, boost: 6}}},
										{match: {page_tag: {query: actualSearchTerm, boost: 5}}},
										{match: {tags: {query: actualSearchTerm, boost: 3}}},
										{match: {description: {query: actualSearchTerm, boost: 4}}},
										{match: {content: {query: actualSearchTerm, boost: 2}}},
										{match: {author: actualSearchTerm}},
									]
								}
							},
							_source: ["title", "description", "url", "page_tag"]
						}
						response = await this.$axios.get(
							`${this.$store.state.config.searchApiHost}/pages/_search`,
							{
								params: {
									source: JSON.stringify(elasticQuery),
									source_content_type: 'application/json'
								},
								auth:{
									username:"sfc_query",
									password:"sfc_query"
								}
							}
						)
						results = response.data.hits.hits
						total = response.data.hits.total
					}
				} catch (e){
					showError = true
					let mutationQuery = `
						mutation{
							send_elasticsearch_email(url: "${this.$route.fullPath}")
						}
					`
					response = await this.$httpService.graphql(mutationQuery)
				}

				this.ready = true
				this.results = results
				this.total = total
				this.actualSearchTerm = actualSearchTerm
				this.searchTerm = searchTerm
				this.pageNumber = pageNumber
				this.tags = tags
				this.searchOnlyByTag = searchOnlyByTag
				this.currentResultFrom = currentResultFrom
				this.showError = showError

			},
			lastPageResultsTotal(){
				if ((((this.pageNumber - 1) * 12) + 12) > this.total){
					return this.total
				}
				return ((this.pageNumber - 1) * 12) + 12
			},
			setCurrentResultFrom(result){
				this.searchTerm = result
				this.currentResultFrom = result
				this.search("", null, false)
			},
			tagClass(tag){
				if(tag == "Article")
					return "article"
				if(tag == "Plan Info")
					return "plan-info"
				if(tag == "Tools & Calculators")
					return "tools-and-calculators"
				if(tag == "Guides")
					return "guides"
				if(tag == "Q & A")
					return "q-and-a"

			},
			paragraphTruncator(paragraph){
				let paragraphToReturn = ""
				if(paragraph.length <= 260){
					return paragraph
				}

				let words = paragraph.split(" ")
				for(let word of words){
					if(paragraphToReturn.length + word.length <= 260){
						paragraphToReturn += ` ${word}`
					}else{
						break
					}
				}

				return `${paragraphToReturn}...`

			},
			loadMoreResults(isVisible, entry){
				if(isVisible){
					this.searchMoreMobile()
				}
			},
			async search(previousOrNext = "", $event, searchOnlyByTag){
				let query
				this.searchOnlyByTag = !!searchOnlyByTag

				if($event){
					$event.stopPropagation();
					$event.preventDefault();
				}

				if(!this.searchOnlyByTag){
					if(this.searchTerm == ""){
						return
					}

					if(this.searchTerm == this.actualSearchTerm && previousOrNext == ""){
						return
					}

					this.currentResultFrom = "All"
				}

				this.keepSearchingMobile = true

				if(previousOrNext == "next"){
					this.pageNumber += 1
				}

				if(previousOrNext == "previous"){
					this.pageNumber -= 1
				}

				if(previousOrNext == ""){
					this.pageNumber = 1
				}

				if(this.searchOnlyByTag){
					query = {
						size: 12,
						from: ((this.pageNumber - 1) * 12),
						query: {
							bool:{
								should:[
									{match_phrase: {tags: this.currentResultFrom}},
								]
							}
						},
						_source: ["title", "description", "url", "page_tag"]
					}
				}else{
					query = {
						size: 12,
						from: ((this.pageNumber - 1) * 12),
						query: {
							bool:{
								should:[
									{match: {title: {query: this.searchTerm, boost: 6}}},
									{match: {page_tag: {query: this.searchTerm, boost: 5}}},
									{match: {tags: {query: this.searchTerm, boost: 3}}},
									{match: {description: {query: this.searchTerm, boost: 4}}},
									{match: {content: {query: this.searchTerm, boost: 2}}},
									{match: {author: this.searchTerm}},
								]
							}
						},
						_source: ["title", "description", "url", "page_tag"]
					}
				}

				let response = await this.$axios.get(
					`${this.$store.state.config.searchApiHost}/pages/_search`,
					{
						params: {
							source: JSON.stringify(query),
							source_content_type: 'application/json'
						},
						auth:{
							username:"sfc_query",
							password:"sfc_query"
						}
					}
				)

				if(!searchOnlyByTag){
					this.actualSearchTerm = this.searchTerm
				}
				this.results = response.data.hits.hits

				let queryString = {}

				if(searchOnlyByTag){
					queryString.tag = this.currentResultFrom
				}

				if(!searchOnlyByTag){
					queryString.q = this.actualSearchTerm
				}

				if(this.$route.query.page || this.pageNumber > 1){
					queryString.page = this.pageNumber
				}

				this.$router.push({query: queryString})

				this.total = response.data.hits.total
				try{
					window.scrollTo(0,0)
				} catch (e) {
					console.error('An error occurred while scrolling to the top of the page:', e)
				}

			},
			async searchMoreMobile(){
				if(this.results.length == this.total || !this.keepSearchingMobile){
					return
				}
				this.pageNumber += 1

				let query

				if(this.currentResultFrom != "All"){
					query = {
						size: 12,
						from: ((this.pageNumber - 1) * 12),
						query: {
							bool:{
								should:[
									{match_phrase: {tags: this.currentResultFrom}},
								]
							}
						},
						_source: ["title", "description", "url", "page_tag"]
					}

				}else{

					if(this.actualSearchTerm.trim() == ""){
						return
					}

					query = {
						size: 12,
						from: ((this.pageNumber - 1) * 12),
						query: {
							bool:{
								should:[
									{match: {title: {query: this.actualSearchTerm, boost: 6}}},
									{match: {page_tag: {query: this.actualSearchTerm, boost: 5}}},
									{match: {tags: {query: this.actualSearchTerm, boost: 3}}},
									{match: {description: {query: this.actualSearchTerm, boost: 4}}},
									{match: {content: {query: this.actualSearchTerm, boost: 2}}},
									{match: {author: this.actualSearchTerm}},
								]
							}
						},
						_source: ["title", "description", "url", "page_tag"]
					}
				}

				this.loadingMoreMobile = true
				let response = await this.$axios.get(
					`${this.$store.state.config.searchApiHost}/pages/_search`,
					{
						params: {
							source: JSON.stringify(query),
							source_content_type: 'application/json'
						},
						auth:{
							username:"sfc_query",
							password:"sfc_query"
						}
					}
				)

				this.results = this.results.concat(response.data.hits.hits)
				this.total = response.data.hits.total

				if(response.data.hits.hits.length == 0){
					this.keepSearchingMobile = false
				}
				this.loadingMoreMobile = false

			},

			goToSearch(search_term){
				window.location.href = '/search?q=' + search_term;
				return true
			}

		}
	}
</script>
